import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=fccd690e"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=fccd690e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports